import { BeneficiaryContribution } from "@/types/contributions";
import { useTranslation } from "react-i18next";
import InputCounter from "@/components/Common/Input/InputCounter";

export const AllocationRow = ({
  beneficiary,
  type,
  onUpdate,
  fundTotal,
  beneficiaries,
}: {
  beneficiary: BeneficiaryContribution;
  type: "personal" | "employer";
  onUpdate: (beneficiaryId: number, newPercentage: number) => void;
  fundTotal: number;
  beneficiaries: BeneficiaryContribution[];
}) => {
  const { t } = useTranslation();
  const amount =
    type === "personal"
      ? beneficiary.employeeContributionInDollars
      : beneficiary.employerContributionInDollars;

  const allocationPercent = fundTotal > 0 ? (amount / fundTotal) * 100 : 0;

  // Calculate remaining percentage available for this beneficiary
  /*  const othersTotal = beneficiaries
    .filter((b) => b.beneficiaryId !== beneficiary.beneficiaryId)
    .reduce((sum, b) => {
      const otherAmount =
        type === "personal"
          ? b.employeeContributionInDollars
          : b.employerContributionInDollars;
      return sum + (fundTotal > 0 ? (otherAmount / fundTotal) * 100 : 0);
    }, 0);

  const maxAllowedPercentage = Math.max(0, 100 - othersTotal);
 */
  const handlePercentageChange = (_: string, newPercentage: number) => {
    onUpdate(beneficiary.beneficiaryId, newPercentage);
  };

  return (
    <div className="px-[16px] py-[32px] md:p-[32px] border-t">
      <h3 className="font-normal text-black text-[18px] mb-[16px]">
        {beneficiary.fullName}
      </h3>

      <div
        style={{
          boxShadow:
            "0px 4px 16px 0px rgba(0, 0, 0, 0.04), 0px 2px 3px 0px rgba(0, 0, 0, 0.05)",
        }}
        className="w-full p-[8px] border-[1px] border-[#E2E2E2] rounded-[12px]"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-[24px]">
          <div className="flex items-center justify-between">
            <InputCounter
              label="Allocation (%)"
              name={`${beneficiary.fullName}Contribution`}
              initialValue={allocationPercent}
              min={0}
              step={1}
              onChange={handlePercentageChange}
              isLong
              prefix=""
              max={100}
              disabled={beneficiaries.length === 1}
              showToolTip
              tooltipText={t(
                "onboarding.contributions.allocation_tooltips.allocation_percentage"
              )}
            />
          </div>
          <div className="py-[8px] leading-[127%]">
            <div className="">
              <div className="font-normal text-[14px] leading-[127%] text-[#7D8688] mb-1">
                In USD (approx.)
              </div>
              <div className="font-normal text-[18px] leading-[127%]">
                ${amount.toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
